import { readable, writable, derived, } from "svelte/store";
import am from "../dal/am";
import { getCurrencyBalance } from "../dal/wax";
import * as Balance from "./Balance";
import * as Asset from "./Asset";
import "./Staking";
import { fetchAccountCollectionStaking, fetchStakingConfigs, getAccountAssets, getAlcorPrice, getWaxPriceInUSD, } from "../dal/integration";
import { ALCOR_MARKET, } from "./types";
/**
 * account will be extracted from query params,
 * I didn't found a svelte/store mechanism to introduce these
 * side effects in it
 * TODO: move to domain
 */
export const accountQueryParams = {
    /**
     * get account for query params
     */
    get() {
        const search = new URLSearchParams(document.location.search);
        return search.get("account") || "";
    },
    /**
     * get account for query params
     */
    set(account) {
        const search = new URLSearchParams(document.location.search);
        search.set("account", account);
        history.pushState(null, document.title, "?" + search.toString());
    },
};
export const account = writable(accountQueryParams.get());
export const currencyBalance = derived(account, ($account, set) => {
    getCurrencyBalance($account).then((balance) => set(Balance.calcBalances(balance || [])));
}, []);
export const accountAssets = derived(account, ($account, set) => {
    getAccountAssets($account).then((assets) => set(assets || []));
}, []);
export const accountLands = derived(accountAssets, ($accountAssets, set) => {
    async function doWork() {
        const lands = Asset.getLands($accountAssets);
        const landAssets = await Promise.all(lands.map((land) => am.getAsset(land.asset_id)));
        set(landAssets || []);
    }
    doWork();
}, []);
export const poolStakingConfig = readable(new Map(), (set) => {
    fetchStakingConfigs().then((config) => set(new Map(config.map((col) => [col.id, col]))));
});
export const accountStakingPower = derived([account, poolStakingConfig], ([$account, $poolStakingConfig], set) => {
    async function doWork() {
        const collectionNames = [...$poolStakingConfig.keys()].map((collectionName) => collectionName);
        const collectionsStaking = await Promise.all(collectionNames.map((col) => fetchAccountCollectionStaking($account, col)));
        set(collectionsStaking.filter((col) => !!col));
    }
    doWork();
}, []);
export const miningPower = writable(0.0);
export const landsIncome = writable(0.0);
// TODO move to domain
function createNightMode() {
    const enabled = localStorage.getItem("dark-mode") || "false";
    const { subscribe, set } = writable(enabled === "true");
    return {
        subscribe,
        toggle: () => {
            const on = localStorage.getItem("dark-mode") || "false";
            if (on == "true") {
                localStorage.setItem("dark-mode", "false");
                set(false);
            }
            else {
                localStorage.setItem("dark-mode", "true");
                set(true);
            }
        },
    };
}
export const nightMode = createNightMode();
export const waxPrice = readable(0.0, function start(set) {
    getWaxPriceInUSD().then((wp) => set(wp.wax.usd));
});
export const aetherPrice = readable(0.0, function start(set) {
    return setAlcorPriceWithInterval(ALCOR_MARKET.AETHER, set);
});
export const wecanPrice = readable(0.0, function start(set) {
    return setAlcorPriceWithInterval(ALCOR_MARKET.WECAN, set);
});
export const caponPrice = readable(0.0, function start(set) {
    return setAlcorPriceWithInterval(ALCOR_MARKET.CAPON, set);
});
export const waxonPrice = readable(0.0, function start(set) {
    return setAlcorPriceWithInterval(ALCOR_MARKET.WAXON, set);
});
export const eneftPrice = readable(0.0, function start(set) {
    return setAlcorPriceWithInterval(ALCOR_MARKET.ENEFT, set);
});
function setAlcorPriceWithInterval(market, set, frequence = 10000) {
    getAlcorPrice(market).then((ap) => set(ap.last_price));
    const interval = setInterval(() => {
        getAlcorPrice(market).then((ap) => set(ap.last_price));
    }, frequence);
    return function stop() {
        clearInterval(interval);
    };
}
export const pricesInWax = derived([aetherPrice, caponPrice, eneftPrice, waxonPrice, wecanPrice], ([$aetherPrice, $caponPrice, $eneftPrice, $waxonPrice, $wecanPrice]) => {
    return {
        AETHER: $aetherPrice,
        CAPON: $caponPrice,
        ENEFT: $eneftPrice,
        WAXON: $waxonPrice,
        WECAN: $wecanPrice,
    };
});
